import { ITipoConsumo } from './ITipoConsumo'

export interface IProduto {
  IdProduto: number
  Descricao: string
  DescricaoProduto: string
  Ativo: boolean
  Inclusao: Date
  Atualizacao: Date | null
}

export interface IProdutoTipoConsumo{
  Produto: IProduto
  TipoConsumo: ITipoConsumo[]
}

export enum IProdutosEnum {
    id_veles = 1,
    api_veles = 2,
    ia_veles = 3,
    segmentaca = 4,
    dash_veles = 5,
    geo_veles = 6,
    web_veles = 7,
    mkt_veles = 8,
    auto_veles = 9,
    scrappy_veles = 10,
    lurik = 12
}